<template>
  <div class="room-chat-form-component" 
       :class="[
           type, 
           `section-${section}`, 
           {'mine': isMine}, 
           {'fix': isFixed},
           {'whisper': isWhisper},
           {'staff': isWhisperStaff},
           ]"
  >
    <div class="room-chat-info"
         v-if="!isMyChat&&!isSystemNoti">
      <span class="room-chat-user-nickname sender align-top" v-tooltip="item.nickname" v-html="item.nickname"></span>
      <img v-if="isWhisper" src="@/assets/images/camstudy/ico_polygon_gray.svg" :alt="$t('chat.whisper.target.default')" class="room-chat-user-nickname receiver inline-block pb-1 align-top relative top-1" />
      <span class="room-chat-user-nickname receiver align-top" v-tooltip="item.receiveUser" v-html="item.receiveUser"></span>
      <span v-if="isWhisper" class="room-chat-user-nickname receiver align-top">({{$t('chat.whisper.target.default')}})</span>
    </div>
    <div class="room-chat-form" :class="{'w-full': isSystemNoti}">
      <div class="relative avatar-container">
        <GrmAvatar v-if="!isMyChat&&!isSystemNoti"
                   :icon="profileIcon"
                   :src="avatarSrc"
        />
        <div class="icon-container" v-if="isOpener(item.userId)&&!item.isFile &&!isSystemNoti"></div>
<!--        <div class="icon-container" v-if="isSystemNoti">-->
<!--          <GrmIcon icon="info" class="!w-4" />-->
<!--        </div>-->
      </div>
      <div class="room-chat">
        
        <!-- my-chat-not-yet-responded -->
        <template v-if="isMyChat && !isSystemNoti">
          <div class="room-chat-message-wrapper" style="opacity: 0.6;">
            <div class="room-chat-message-loading">
              <p class="room-chat-message-loading-text">{{ $t("chat.form.sending") }}</p>
            </div>
            <pre class="room-chat-message me" v-html="item.myChats" />
          </div>
        </template>

        <template v-else-if="isSystemNoti">
          <div class="noti-container">
            <div class="notice-content">
              {{item.content}}
            </div>
          </div>
        </template>

        <!-- default -->
        <template v-else>
          <div class="room-chat-message-wrapper">
            <div class="relative">
              <pre class="room-chat-message" v-html="content"/>
            </div>
          </div>
        </template>
      </div>
      <p class="room-chat-time"
         v-if="item.receiveDate && !isSystemNoti">{{ item.receiveDate }}</p>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import GrmAvatar from "@/components/Common/avatar/GrmAvatar";

export default {
  name: 'ChatForm',
  components: {
    GrmAvatar,
  },
  props: {
    section: {
      type: String,
      default: 'chat',
    },
    type: {
      type: String,
    },
    item: {
      type: Object,
      required: true
    },
    menuList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isOpenChatMoreList: false,
    }
  },
  computed: {
    ...mapGetters('user', [
      'me',
      'isOpener',
      'getRoomUser',
      'hasEmceeRole',
      'hasSpeakerRole',
      'isParticipantRole',
    ]),
    isSystemNoti(){
      return this.type === 'systemMsg'
    },
    isMyChat(){
      return this.type === 'my-chat'
    },
    isFixed(){
      return this.item?.fixed
    },
    isWhisper(){
      return this.item.target === 'whisper'
    },
    isWhisperStaff(){
      return this.item.target === 'staff'
    },
    profileIcon(){
      if(this.isNoticeSection)
        return '';
      else if(this.isWhisper || this.isWhisperStaff)
        return this.item.target;
      else
        return this.type;
    },
    content() {
      if(!this.item) return
      let content = this.item.text ||
          this.item.content;
      return content && content.escapeXml();
    },
    isMine(){
      return this.isMyChat || this.item?.userId === this.me.userId;
    },
    avatarSrc () {
      return this.item?.profileImageUrl ? this.item?.profileImageUrl : '';
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.room-chat-form-component{
  margin-top: 16px;
}
.room-chat-form-component {
  .room-chat {
    margin-left: 12px;
    margin-right: 0;
  }
  &.mine{
    text-align: right;
    .room-chat{
      margin-left: 0;
      margin-right: 12px;
    }
    .room-chat-message{
      background: #192F49;
    }
  }
  &.mine .room-chat-form{
    flex-direction: row-reverse;
  }
  &.mine.chat{
    .room-chat-user-nickname {
      &.sender {
        //color: $mainColor;
      }
    }
  }
  &:not(.mine){
    .room-chat-user-nickname {
      &.receiver {
        //color: $mainColor;
        margin-left: 2px;
      }
    }
  }
  .room-chat-user-nickname {
    &.receiver {
      //color: $mainColor;
      margin-left: 2px;
    }
  }
  &.systemMsg {
    .room-chat-form {
      display: inline-flex;
      gap: 4px;

      .room-chat-message-wrapper {
        position: relative;

        .room-chat-message {
          color: #FFF;
          font-size: 14px;
          line-height: 140%;
          word-break: break-all;
          white-space: break-spaces;
          cursor: default;

          border-radius: 6px;
          background: #393939;
          padding: 8px 12px;
        }
      }
    }
  }
}
.room-chat-form {
  display: inline-flex;
  gap: 4px;
}
.room-chat {
  min-width: 0;
  flex: 1;
  position: relative;
}
.room-chat-form-component.mine{
  .room-chat-info {
    height: 14px;
    margin-bottom: 4px;
    margin-right: 52px;
  }
}
.room-chat-form-component:not(.mine){
  .room-chat-info {
    height: 14px;
    margin-bottom: 4px;
    margin-left: 52px;
  }
}
.room-chat-info {
  flex: 1;
  min-width: 0;
}
.room-chat-user-nickname {
  flex: 1;
  min-width: 0;
  //max-width: max-content;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #999;
  font-size: 9px;
  font-style: normal;
  line-height: 150%;
}
.my-chat {
  .room-chat-form {
    padding: 0px 8px 8px 16px;
  }
  .room-chat-message {
    //text-align: right;
    padding-left: 40px;
  }
  .room-chat-message-wrapper {
    display: flex;
    align-items: center;
    position: relative;
    //transform: translateY(-8px);
  }
}
.room-chat-time {
  color: #999;
  white-space: nowrap;
  font-size: 9px;
  line-height: 150%;
  display: flex;
  align-items: flex-end;
}
.room-chat-message-wrapper {
  position: relative;
}
.room-chat-message-wrapper{
  .stt::before{
    content: 'stt';
    position: absolute;
    font-size: 11px;
    top: -6px;
    left: -10px;
    padding: 1px 4px;
    background: #f8f8f8;
    box-shadow: 1px 1px 1px 0 rgba(0,0,0,0.4);
    border-radius: 5px;
  }
  .translation{
    color: $mainColor;
  }
  .translation::before{
    content: 'translate';
    position: absolute;
    font-size: 11px;
    top: -7px;
    left: -10px;
    padding: 1px 4px;
    color: black;
    background: #f8f8f8;
    box-shadow: 1px 1px 1px 0 rgba(0,0,0,0.4);
    border-radius: 5px;
  }
}
.room-chat-message-loading {
  position: absolute;
  top: 6px;
  left: -6px;
}
.room-chat-message-loading-text {
  font-size: 10px;
}
.room-chat-message {
  color: #FFF;
  font-size: 14px;
  line-height: 140%;
  word-break: break-all;
  white-space: break-spaces;
  cursor: default;

  border-radius: 6px;
  background: #393939;
  padding: 8px 12px;
}
.room-chat-file-info {
  display: flex;
  flex-direction: column;
  gap: 6px 0;
  position: relative;
}
.room-chat-file-name {
  padding-right: 40px;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.4;
  word-break: break-all;
  cursor: default;
}
.room-chat-file-detail-info {
  display: flex;
  align-items: center;
  cursor: default;
}
.room-chat-file-size {
  font-size: 11px;
  color: #999;
}
.room-chat-file-time {
  font-size: 11px;
  color: #999;
  display: flex;
  align-items: center;
  &::before {
    content: '';
    width: 1px;
    height: 8px;
    margin: 0 8px;
    background-color: #ccc;
    display: block;
  }
}
.room-chat-file-period {
  font-size: 12px;
  color: #999;
  cursor: default;
}
.room-chat-file-progress {
  margin-top: 10px;
  position: relative;
}
.room-chat-file-percent {
  font-size: 12px;
  color: #999;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  position: absolute;
  right: 6px;
  bottom: 10px;
}
.room-chat-file-percent-number {
  margin-right: 6px;
  font-size: 20px;
  font-weight: 700;
  color: #333;
}
.room-chat-file-progress-bar-wrapper {
  height: 2px;
  border-radius: 2px;
  background-color: rgba(0, 0, 0, 0.1);
}
.room-chat-file-progress-bar {
  height: 100%;
  background-color: $mainColor;
}
.room-chat-file-download-button {
  position: absolute;
  right: 6px;
  bottom: 0;
  width: 36px;
  height: 36px;
  border-radius: 100%;
  background: #f4f4f4 url('~@/assets/images/download.svg') no-repeat center / 16px auto;
  &:hover {
    background: $mainColor url('~@/assets/images/download_white.svg') no-repeat center / 16px auto;
  }
}
.room-chat-more {
  position: absolute;
  top: -6px;
  right: 0;
}
.room-chat-more-button {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: url('~@/assets/images/more_vertical.svg') no-repeat center / 3px auto;
  opacity: 0.6;
  &:hover {
    background-color: #f1f1f1;
    opacity: 1;
  }
}

// Component
.grm-menu-component {
  position: absolute;
  top: 4px;
  right: 16px;
}
.avatar-container{
}
.icon-container{
  position: absolute;
  top: 22px;
  right: 0;
  border-radius: 6px;
  width: 14px;
  height: 14px;
  background: #FF7F00 url("~@/assets/images/crown_white.svg") no-repeat center / auto 72%;
  box-sizing: content-box;
  border: 2px solid #1F1F1F;
}
.noti-container{
  display: flex;
  justify-content: center;
  .notice-content{
    border-radius: 20px;
    background: #393939;
    padding: 4px 10px;
    color: #FFF;
    font-size: 10px;
    font-weight: 400;
    line-height: 140%;
  }
}
</style>